import ServiceList from "./service-list";
export default ServiceList;